// extracted by mini-css-extract-plugin
export default {"appWrapper":"app_appWrapper__06mHR","layout":"app_layout__33csa","footer":"app_footer__8+FfT","envButton":"app_envButton__qTuQV"};